import { getStateColors } from './icon_helpers';

/**
 * Creates a evacuation safety points - emergency exit icon
 * @param {string|null} state - Asset state ('available', 'locked_out', etc.)
 * @returns {string} Data URL containing SVG icon
 */
export const createEmergencyExitIcon = (state = null) => {
  const colors = getStateColors(state);

  const svgContent = `
    <svg width="226" height="336" viewBox="0 0 226 336" xmlns="http://www.w3.org/2000/svg">
      <!-- Pin base -->
      <path d="M203 123.75 C203 80.565 168.435 45 123.75 45 S44.5 80.565 44.5 123.75 c0 43.185 79.25 173.25 79.25 173.25 s79.25-130.065 79.25-173.25 z" fill="${colors.pinColor}"/>

      <!-- Icon background circle -->
      <circle cx="123.75" cy="123.75" r="52.47" fill="${colors.ringColor}" stroke="${colors.ringColor}" stroke-width="12.6"/>
      <circle cx="123.75" cy="123.75" r="37.8" fill="white"/>

      <!-- evacuation safety points - emergency exit icon (scaled and centered) -->
      <g transform="translate(123.75, 123.75) scale(3.2) translate(-21, -21)">
        <g  transform="translate(9 9)">
<circle fill="${colors.iconColor}" cx="9" cy="6" r="1.5" /><path fill="${colors.iconColor}" d="M8 8l-1 3 1.5.7V16h1.5v-4.3l1.5-.7L11 8z" /><path fill="${colors.iconColor}" d="M19 12l-4-4v3H9v2h6v3z" /><path fill="${colors.iconColor}" d="M4 4v16h8" />
    </g>
      </g>
    </svg>
  `;

  return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svgContent);
};

/**
 * Creates a evacuation safety points - emergency shelter icon
 * @param {string|null} state - Asset state ('available', 'locked_out', etc.)
 * @returns {string} Data URL containing SVG icon
 */
export const createEmergencyShelterIcon = (state = null) => {
  const colors = getStateColors(state);

  const svgContent = `
    <svg width="226" height="336" viewBox="0 0 226 336" xmlns="http://www.w3.org/2000/svg">
      <!-- Pin base -->
      <path d="M203 123.75 C203 80.565 168.435 45 123.75 45 S44.5 80.565 44.5 123.75 c0 43.185 79.25 173.25 79.25 173.25 s79.25-130.065 79.25-173.25 z" fill="${colors.pinColor}"/>

      <!-- Icon background circle -->
      <circle cx="123.75" cy="123.75" r="52.47" fill="${colors.ringColor}" stroke="${colors.ringColor}" stroke-width="12.6"/>
      <circle cx="123.75" cy="123.75" r="37.8" fill="white"/>

      <!-- evacuation safety points - emergency shelter icon (scaled and centered) -->
      <g transform="translate(123.75, 123.75) scale(3.2) translate(-21, -21)">
        <g  transform="translate(9 9)">
<path fill="${colors.iconColor}" d="M12 3l-9 6v11h18V9z" /><rect fill="none" stroke="${colors.iconColor}" stroke-width="2" x="9" y="14" width="6" height="6" /><path fill="${colors.iconColor}" d="M3 9l9-6 9 6" />
    </g>
      </g>
    </svg>
  `;

  return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svgContent);
};

/**
 * Creates a evacuation safety points - evacuation point assembly area icon
 * @param {string|null} state - Asset state ('available', 'locked_out', etc.)
 * @returns {string} Data URL containing SVG icon
 */
export const createEvacuationPointAssemblyAreaIcon = (state = null) => {
  const colors = getStateColors(state);

  const svgContent = `
    <svg width="226" height="336" viewBox="0 0 226 336" xmlns="http://www.w3.org/2000/svg">
      <!-- Pin base -->
      <path d="M203 123.75 C203 80.565 168.435 45 123.75 45 S44.5 80.565 44.5 123.75 c0 43.185 79.25 173.25 79.25 173.25 s79.25-130.065 79.25-173.25 z" fill="${colors.pinColor}"/>

      <!-- Icon background circle -->
      <circle cx="123.75" cy="123.75" r="52.47" fill="${colors.ringColor}" stroke="${colors.ringColor}" stroke-width="12.6"/>
      <circle cx="123.75" cy="123.75" r="37.8" fill="white"/>

      <!-- evacuation safety points - evacuation point assembly area icon (scaled and centered) -->
      <g transform="translate(123.75, 123.75) scale(3.2) translate(-21, -21)">
        <g  transform="translate(9 9)">
<circle fill="${colors.iconColor}" cx="12" cy="5" r="2" /><path fill="${colors.iconColor}" d="M14 8h-4l-1 3 2 .7V18h2v-6.3l2-.7z" /><path fill="${colors.iconColor}" d="M9 11l-3 1.5M15 11l3 1.5" /><rect fill="${colors.iconColor}" x="6" y="19" width="12" height="2" /><rect fill="${colors.iconColor}" x="7" y="21.5" width="10" height="1.5" />
    </g>
      </g>
    </svg>
  `;

  return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svgContent);
};

/**
 * Creates a evacuation safety points - muster point icon
 * @param {string|null} state - Asset state ('available', 'locked_out', etc.)
 * @returns {string} Data URL containing SVG icon
 */
export const createMusterPointIcon = (state = null) => {
  const colors = getStateColors(state);

  const svgContent = `
    <svg width="226" height="336" viewBox="0 0 226 336" xmlns="http://www.w3.org/2000/svg">
      <!-- Pin base -->
      <path d="M203 123.75 C203 80.565 168.435 45 123.75 45 S44.5 80.565 44.5 123.75 c0 43.185 79.25 173.25 79.25 173.25 s79.25-130.065 79.25-173.25 z" fill="${colors.pinColor}"/>

      <!-- Icon background circle -->
      <circle cx="123.75" cy="123.75" r="52.47" fill="${colors.ringColor}" stroke="${colors.ringColor}" stroke-width="12.6"/>
      <circle cx="123.75" cy="123.75" r="37.8" fill="white"/>

      <!-- evacuation safety points - muster point icon (scaled and centered) -->
      <g transform="translate(123.75, 123.75) scale(3.2) translate(-21, -21)">
        <g  transform="translate(9 9)">
<circle fill="${colors.iconColor}" cx="7" cy="5" r="1.5" /><circle fill="${colors.iconColor}" cx="12" cy="5" r="1.5" /><circle fill="${colors.iconColor}" cx="17" cy="5" r="1.5" /><path fill="${colors.iconColor}" d="M6 7l-1 2.5L6.5 10v4H8v-4l1.5-.5L9 7z" /><path fill="${colors.iconColor}" d="M11 7l-1 2.5L11.5 10v4H13v-4l1.5-.5L14 7z" /><path fill="${colors.iconColor}" d="M16 7l-1 2.5L16.5 10v4H18v-4l1.5-.5L19 7z" /><rect fill="${colors.iconColor}" x="3" y="16" width="18" height="2" /><rect fill="${colors.iconColor}" x="3" y="19" width="18" height="1.5" />
    </g>
      </g>
    </svg>
  `;

  return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svgContent);
};

export const evacuationsafetypointsIcons = {
  emergency_exit: createEmergencyExitIcon,
  emergency_shelter: createEmergencyShelterIcon,
  evacuation_point_assembly_area: createEvacuationPointAssemblyAreaIcon,
  muster_point: createMusterPointIcon
};
